import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthForm from './components/auth/AuthForm';
import ChatInterface from './components/chat/ChatInterface';
import OAuthCallback from './components/auth/OAuthCallback';  // ADD THIS IMPORT
import RequireAuth from './components/auth/RequireAuth';
import { Moon, Sun } from "lucide-react";

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    return savedTheme ? savedTheme === "dark" : true;
  });

  useEffect(() => {
    localStorage.setItem("theme", darkMode ? "dark" : "light");
  }, [darkMode]);

  return (
    <div
      className={`flex flex-col min-h-screen transition-all duration-300 ${darkMode
          ? "bg-ink-950 text-white"
          : "bg-slate-100 text-slate-900"
        }`}
    >
      <main className="flex-1 p-0">
        <Routes>
          <Route
            path="/login"
            element={
              <AuthForm
                darkMode={darkMode}
                setDarkMode={setDarkMode}
              />
            }
          />
          <Route path="/oauth/callback" element={<OAuthCallback />} />  {/* ADD THIS ROUTE */}
          {/* Same component as /login — AuthForm reads ?token=&email= itself
              and switches into its RESET_PASSWORD mode. Without this route,
              the catch-all below redirects here and drops the query string,
              making every emailed reset link a dead end. */}
          <Route
            path="/reset-password"
            element={
              <AuthForm
                darkMode={darkMode}
                setDarkMode={setDarkMode}
              />
            }
          />
          <Route
            path="/chat"
            element={
              <RequireAuth>
                <ChatInterface
                  darkMode={darkMode}
                  setDarkMode={setDarkMode}
                />
              </RequireAuth>
            }
          />
          <Route
            path="/chat/:threadId"
            element={
              <RequireAuth>
                <ChatInterface
                  darkMode={darkMode}
                  setDarkMode={setDarkMode}
                />
              </RequireAuth>
            }
          />
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
